import axios from "axios";
import Cookies from "js-cookie";

const GetSites = async (authToken = Cookies.get('skyarc-auth-8080')) => {
    try {
        const headers = { "Authorization": "BEARER authToken=" + authToken, "Accept":"application/json" }    
        const dataResponse = await axios.get('https://infinity.skyspark.nl/api/portal/eval?expr=inf_api_sites()',{
            headers
        })
        if(dataResponse.status === 200) return dataResponse
        else return []
    } catch {
        return [];
    }
}
export default GetSites;